import clsx from 'clsx';
import { colors } from '../foundation';
import Info from '../svg/State/Info';
import Success from '../svg/State/Success';
import Warning from '../svg/State/Warning';
import { Paragraph } from '../typography';
import { InputState, Link } from './types';

type Props = {
  id: string | undefined;
  label?: string;
  subText?: string;
  helperText?: string;
  link?: Link;
  inputState?: InputState;
  children?: React.ReactElement;
  hideStateIcon?: boolean;
};

const getInputStateIcon = (type: InputState['type']) => {
  switch (type) {
    case 'success':
      return <Success />;
    case 'error':
      return <Warning color={colors.state.error} />;
    case 'warning':
      return <Warning color={colors.state.warning} />;
    case 'info':
    default:
      return <Info />;
  }
};

const InputWrapper = ({ id, label, subText, helperText, link, inputState, children, hideStateIcon }: Props) => {
  return (
    <div className="relative flex w-full flex-col gap-8 text-black-50">
      {label && (
        <label htmlFor={id} className="text-md2">
          {label}
        </label>
      )}
      {subText && <Paragraph variant="small">{subText}</Paragraph>}
      {children}
      {inputState && (
        <div className="flex gap-4 px-8">
          {!hideStateIcon && getInputStateIcon(inputState.type)}
          <Paragraph variant="small" classes={clsx({ 'text-state-error': inputState.type === 'error' })}>
            {inputState.message}
          </Paragraph>
        </div>
      )}
      {helperText && <Paragraph variant="small">{helperText}</Paragraph>}
      {link && (
        <a href={link.url} className="w-fit text-sm font-light leading-[18px] underline">
          {link.text}
        </a>
      )}
    </div>
  );
};

export default InputWrapper;
